
























import { computed, defineComponent, ref, watchEffect } from '@vue/composition-api';
import OfflineMapButton from '@/components/map/OfflineMapButton.vue';
import { FieldRow } from '@/store/types';

export default defineComponent({
	components: { OfflineMapButton },
	setup: (props, { root }) => {
		const popupRef = ref<HTMLElement | null>(null);
		const isScrolling = ref<boolean>(false);
		const activeFieldRow = computed<FieldRow | null>(() => {
			const fieldRow: FieldRow | null = root.$store.getters['fieldsView/getActiveFieldRow'];
			if (!fieldRow) {
				return null;
			}

			const { name, producerName, groupName, status, ...rest } = fieldRow;
			return {
				name,
				producerName,
				groupName,
				status: {
					state: status.state,
					timestamp: new Date(status.timestamp).toLocaleString(),
				},
				...rest,
			};
		});

		const handleMouseDown = (ev: MouseEvent | TouchEvent) => {
			ev.stopPropagation();
		};

		const handleClose = (ev: MouseEvent | TouchEvent) => {
			ev.preventDefault();
			ev.stopImmediatePropagation();
			root.$store.dispatch('fieldsView/clearActiveFieldId');
		};

		const handleScroll = (ev: MouseEvent | TouchEvent) => {
			ev.preventDefault();
			ev.stopPropagation();
		};

		const handleTouchStart = () => {
			isScrolling.value = true;
		};

		const handleTouchMove = (ev: TouchEvent) => {
			if (isScrolling.value) {
				ev.preventDefault();
				ev.stopPropagation();
			}
		};

		const handleTouchEnd = () => {
			isScrolling.value = false;
		};

		watchEffect((cleanup) => {
			const ref = popupRef.value;
			if (!ref) {
				return;
			}

			ref.addEventListener('touchstart', handleTouchStart);
			ref.addEventListener('touchmove', handleTouchMove);
			ref.addEventListener('touchend', handleTouchEnd);

			cleanup(() => {
				ref.removeEventListener('touchstart', handleTouchStart);
				ref.removeEventListener('touchmove', handleTouchMove);
				ref.removeEventListener('touchend', handleTouchEnd);
			});
		});

		return {
			popupRef,
			activeFieldRow,
			handleMouseDown,
			handleClose,
			handleScroll,
		};
	},
});
